// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';

const S = {
  Container: styled.div``,
  TooltipWrapper: styled.div`
    display: inline-flex;
    flex-direction: column;
    align-items: flex-end;
    transform: translate(-50%);
    position: relative;
    left: 14px;
  `,
  Text: styled.span`
    padding: 14px 18px;
    background-color: #434343;
    font-size: 14px;
    line-height: 16px;
    color: #FFFFFF;
      border-radius: 4px;
  `,
  ArrowDown: styled.span`
    margin-right: 8px;
    width: 12px;
    height: 6px;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid #434343;
    position: relative;
    top: -1px;
  `,
};

export { S as default }
